import * as actions from "./actions";
import { rootRef } from "../../config/firebase";
import _ from "lodash";

function obtenerSearchDataInscripciones() {
  return dispatch => {
    rootRef.child(`escuelas/verano2018/colegios`).once("value", snap => {
      const datos = snap.val();
      let prom = [];
      _.forOwn(datos, (v, k) => {
        prom.push(rootRef.child(`detalles/colegios/${k}`).once("value"));
      });

      Promise.all(prom)
        .then(resp => {
          let payload = [];
          resp.forEach(item => {
            const { nombre, provincia, poblacion } = item.val();
            payload.push({
              childKey: item.key,
              title: nombre,
              description: `Población: ${poblacion}, Provincia: ${provincia}`
            });
          });
          dispatch(actions.obtenerBusquedaColegiosEscuelas(payload));
        })
        .catch(error => console.log(error));
    });
  };
}

function limpiarSearchDataInscripciones() {
  return actions.limpiarBusquedaColegiosEscuelas();
}

function inscribirEnColegio(payload) {
  return actions.inscribirEnColegio(payload);
}

function resetInscribirEnColegio() {
  return actions.resetInscribirEnColegio();
}

function obtenerDetalleColegio({ idColegio }) {
  let prom = [
    rootRef.child(`detalles/colegios/${idColegio}`).once("value"),
    rootRef.child(`escuelas/verano2018/precios/${idColegio}`).once("value")
  ];

  return dispatch => {
    Promise.all(prom)
      .then(resp => {
        const id = resp[0].key;
        let payload = resp[0].val();
        payload.id = id;

        payload.precios = resp[1].val();

        dispatch(actions.obtenerDetalleColegio(payload));
      })
      .catch(error => error);
  };
}

function limpiarDetalleColegio() {
  return actions.limpiarDetalleColegio();
}

function guardarInscripcion({ values, idColegio }) {
  return dispatch => {
    const idAlumno = rootRef
      .child(`escuelas/verano2018/preinscripciones/${idColegio}`)
      .push().key;

    let insert = {};
    insert[
      `escuelas/verano2018/preinscripciones/${idColegio}/${idAlumno}`
    ] = values;

    insert[
      `escuelas/verano2018/preinscripciones_resguardos/${idColegio}/${idAlumno}`
    ] = {
      childKey: idAlumno,
      title: idAlumno
    };

    rootRef.update(insert, () =>
      dispatch(
        actions.dataSaved({
          status: true,
          message: "Se ha guardado la preinscripcion",
          resguardo: idAlumno
        })
      )
    );
  };
}

function resetDataSaved() {
  return actions.resetDataSaved();
}

/*---*/
export {
  obtenerSearchDataInscripciones,
  limpiarSearchDataInscripciones,
  inscribirEnColegio,
  resetInscribirEnColegio,
  obtenerDetalleColegio,
  limpiarDetalleColegio,
  guardarInscripcion,
  resetDataSaved
};



// WEBPACK FOOTER //
// ./src/ducks/inscripciones/operations.js